module.exports = __webpack_public_path__ + "static/img/banner_mobile3.b830b2ae.jpg";